'use strict';

var _ = require('lodash');

module.exports = {
  mergeCurrentStyleWithStateStyle: function (style) {
    var options = this.leafletLayer.options;

    // color should remain unchanged
    var color = options.color;
    var fillColor = options.fillColor;

    return _.extend({}, options, style, {
      color: color,
      fillColor: fillColor
    });
  },
}


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/mixins/PathStyleMixin.js